import script from "./Integrations.vue?vue&type=script&setup=true&lang=js"
export * from "./Integrations.vue?vue&type=script&setup=true&lang=js"

import "./Integrations.vue?vue&type=style&index=0&id=16fdc8e6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16fdc8e6"]])

export default __exports__